import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Clipboard } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component( {
   selector: 'lib-copy-dialog',
   template: `<mat-dialog-content class="copy-dialog">
      <div class="message">{{message}}</div>
      <div class="message-button">
         <button mat-stroked-button color="primary" (click)="copy()">
            <mat-icon>content_copy</mat-icon>
            Copy To Clipboard And Close
         </button>
      </div>
   </mat-dialog-content>`,
   styles: [ `.message { white-space: pre-wrap; }` ],
})
export class CopyDialogComponent {
   message: string;

   constructor(
      public dialogRef: MatDialogRef<CopyDialogComponent>,
      @Inject( MAT_DIALOG_DATA ) public data: any,
      private clipboard: Clipboard,
      private snackbar: MatSnackBar,
   ) {
      this.message = (data.message) ? data.message : 'Hi!';
   }

   copy() {
      this.clipboard.copy( this.message );
      this.snackbar.open( 'Copied!', '', { duration: 1000 });
      this.dialogRef.close();
   }
}
